/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchAlertsResponseItem } from './search-alerts-response-item';


export interface SearchAlertsResponseItemPagedList { 
    totalCount?: number;
    items?: Array<SearchAlertsResponseItem> | null;
}

